import * as msal from '@azure/msal-browser';
import axios from 'axios';
import BaseModelProgram from '@/models/BaseModelProgram.js'
import BaseModelPartner from '@/models/BaseModelPartner.js'
import BaseModelInputControl from '@/models/BaseModelInputControl.js'
import { InvestmentConfig, UnitClassConfig, VestingScheduleConfig } from '../components/forms/ProgramFormConfig';
import apiUtil from './apiUtil';
import { GridConfig as InputControlGridConfig } from '../views/admin/InputControlConfig';
import { ProgramInfoGridConfig } from '../views/summaries/ProgramInfoConfig';
import { GridConfig as PartnerGridConfig} from '../views/summaries/PartnerInfoConfig'
const authUrl = `${process.env.VUE_APP_baseUrl}/api/signin/authenticate`;
const healthUrl = `${process.env.VUE_APP_API_HEALTH_URL}`;
const GRAPH_BASE = 'https://graph.microsoft.com/beta'
const GRAPH_SCOPES = ['user.read', 'user.readbasic.all']
//const UI_SCOPES = ['user.read', 'profile', 'email'];
let UI_SCOPES = process.env.VUE_APP_UI_SCOPES;
//const API_SCOPES = ['openid', 'profile', 'offline_access', 'email', `api://${process.env.VUE_APP_API_CLIENT_ID}/user_impersonation`];
let API_SCOPES = process.env.VUE_APP_API_SCOPES;
console.log(`apiscopes = ${process.env.API_SCOPES}`)
let _rootApp = {};
let msalApp = null;
let _authInst = {};
let _authUrl = null;
let msal_user = null;
let app_user = null;
let vueapp;
let userFullName = null;

const AuthHelper = function () {
  return {
    UI_SCOPES: process.env.VUE_APP_UI_SCOPES,
    API_SCOPES: process.env.VUE_APP_API_SCOPES,
    _msalClient: null,
    _msal_user: null,
    _app_user: null,
    _authUrl: null,
    _rootApp,
    msalClient,
    userFullName,
    ConfigureMsal,
    clientId,
    login,
    // logout,
    user,
    acquireToken,
    acquireIdToken,
    getAppUser,
    getMsalAccount,
    authorizeAPI,
    checkApiHealth,
    //authorize,
    clearLocal,
    isConfigured,
    setMsalClient,
    startInitialLoad
  }
}


const CreateAuthHelper = function (store) {
  let newhelper = AuthHelper();
  newhelper._eumstore = store;

  return newhelper;
};
const _eumstore = function () {

  return this.$app.$store;


};

const msalClient = function () {
  return this._msalClient;
}

const setMsalClient = function (newval) {
  this._msalClient = newval;
  return;
}

const rootApp = function () {
  return _rootApp;
};

const ConfigureMsal = function (clientId, enableDummyUser = false) {
  // Can only call configure once
  if (this._msalClient) {
    return
  }
  // Can't configure if clientId blank/null/undefined
  if (!clientId) {
    return;
  }
  const config = {
    auth: {
      clientId: clientId,
      redirectUri: window.location.origin,
      authority: process.env.VUE_APP_TENANT_ID,
      asyncPopups: false,
      postLogoutRedirectUri: `${process.env.VUE_APP_frontEndUrl}`
    },
    cache: {
      cacheLocation: 'memoryStorage',
      temporaryCacheLocation: 'memoryStorage',
      storeAuthStateInCookie: true,
      secureCookies: true
    },
    // Only uncomment when you *really* need to debug what is going on in MSAL
    system: {
      logger: new msal.Logger(
        (logLevel, msg) => { console.log(msg) },
        {
          level: msal.LogLevel.Verbose
        }
      )
    }
  }

  console.log('Azure AD sign-in: enabled\n', config);
  this._msalClient = new msal.PublicClientApplication(config);
  console.log(this._msalClient);
  return;
};

//
// Return the configured client id
//
function clientId() {
  if (!this._msalClient) {
    return null
  }

  return this._msalClient.config.auth.clientId;
};

//
// Login a user with a popup
//  *** This is not used currently in the middle of refactor ***
//async function login(scopes = ['user.read', 'openid', 'profile', 'email']) {
async function login(scopes = UI_SCOPES) {
  console.log(`[auth.js] login()`);
  if (!this._msalClient) {
    return;
  }

  // first see if the user is already authorized
  if ((this._eumstore.getters['authModule/authorized'] == true) &&
    (this._eumstore.getters['authModule/storedAppUser'] != null)) {
    return this._eumstore.getters['authModule/storedAppUser'];
  }

  let popres;
  // not authorized so get their msal user if it is there
  let msalacct = await this.getMsalAccount();
  if (!msalacct) {

    popres = await this._msalClient.loginPopup({
      scopes,
      title: 'Login Window',
      prompt: 'select_account'
    })

    //set the msalaccount in state
    this._eumstore.dispatch('authModule/SetMsalUser', popres);
    this._msal_user = popres;
    this._eumstore.dispatch('authModule/SetAccessToken', popres.accessToken);
    this._eumstore.dispatch('authModule/SetAuthenticated', true);
    this._eumstore.dispatch('authModule/SetAuthStatus', 2);

  }

  // try to acquire token silently
  const tokens = await this.acquireToken()
  await this._eumstore.dispatch('authModule/SetTokens', tokens);



  let usr = await this.authorizeAPI(tokens);
  if (usr != null) {
    this._eumstore.dispatch('authModule/SetAppUser', usr);
    this._app_user = usr;

    this._eumstore.dispatch('authModule/SetLoggedInUser', usr);
    //this._eumstore.dispatch('authModule/SetFirstAuthFlag',false);
  }
  console.log(this._msalClient);
  return usr;
};


// Call to get user, probably cached and _eumstored locally by MSAL
async function user(doPopup = true) {

  if (!this._msalClient) {
    return null
  }
  let storedUsr = this._eumstore.getters['authModule/storedAppUser'];
  if (storedUsr) {
    return storedUsr;
  }
  else {

    let authstat = this._eumstore.getters['authModule/authStatus'];
    if (authstat == 0 || authstat == 1) {
      //let accounts = await this._msalClient.GetAccountsAsync();
      let atres = await this.acquireToken(['user.read'], doPopup);

      if (!atres) {
        return null;
      } else {
        if (!doPopup) {
          this._eumstore.dispatch("authModule/SetLoginInProgress", true);
        }

        this._eumstore.dispatch('authModule/SetMsalUser', atres.account);

        let apitokenres = await this.acquireIdToken();
     //   this._eumstore._apiIdToken = apitokenres.idToken;
        this._eumstore.dispatch('authModule/SetTokens', apitokenres);

        let usr = await this.authorizeAPI(apitokenres);
        if (usr != null) {

          this._eumstore.dispatch('authModule/SetAppUser', usr);
          this._app_user = usr;
          return usr;
          
          // this._eumstore.dispatch('authModule/SetLoggedInUser', usr);
          //this._eumstore.dispatch('authModule/SetFirstAuthFlag',false);
        }
      }
    }
  }
};

async function getMsalUser() {
  if (!this._msalClient) {
    return null
  }

  let storedUsr = this._eumstore.getters['authModule/storedMsalUser'];

  if (storedUsr) {
    return storedUsr;

  }
  else {
    return null;
  }
};
//
// Call through to acquireTokenSilent or acquireTokenPopup
//
// async function acquireToken(scopes = ['user.read','openid', 'profile', 'offline_access', 'email', `api://${process.env.VUE_APP_API_CLIENT_ID}/user_impersonation`]) {
async function acquireToken(scopes, doPopup = true) {

  if (!this._msalClient) {
    return null
  }

  if (!this._msal_user) {
    this._msal_user = this._msalClient.getAllAccounts()[0];
  }

  // Set scopes for token request
  const accessTokenRequest = {
    scopes,
    account: this._msal_user
  };
  const popupRequest = {
    scopes,
    prompt: 'select_account'
  };
  let tokenResp
  try {
    // 1. Try to acquire token silently
    //if (!accessTokenRequest.account){ throw 'No msal account';}
    tokenResp = await this._msalClient.acquireTokenSilent(accessTokenRequest)
    console.log(`[auth.js] acquireToken() MSAL acquireTokenSilent was successful`);
    this._eumstore.dispatch('authModule/SetAuthStatus', 2);
    this._eumstore.dispatch('authModule/SetTokens', tokenResp);
    console.log(tokenResp);
    this._msalClient.retrievedIdToken = tokenResp.idToken;
    this._msalClient.idToken = tokenResp.idToken;
    return tokenResp;

  } catch (err) {
    // 2. Silent process might have failed so try via popup

    if (doPopup) {
      tokenResp = await this._msalClient.acquireTokenPopup(popupRequest)
      this._eumstore.dispatch('authModule/SetAuthStatus', 2);
      this._msalClient.retrievedIdToken = tokenResp.idToken;
      this._msalClient.idToken = tokenResp.idToken;
      this._eumstore.dispatch('authModule/SetTokens', tokenResp);
      console.log(`[auth.js] acquireToken() acquireTokenPopup was successful`);

      return tokenResp;
    }
    else {
      return null;
    }
  }


  // Just in case check, probably never triggers
  if (!tokenResp.accessToken) {
    throw new Error(`[auth.js] acquireToken() accessToken not found in response, that is bad`);
  }

  return tokenResp.accessToken;
};

async function acquireIdToken(scopes = ['openid', 'profile', 'offline_access', 'email', `api://${process.env.VUE_APP_API_CLIENT_ID}/user_impersonation`]) {
  let usr = this._msalClient.getAllAccounts()[0];
  
  const accessTokenRequest = {
    scopes,
    account: usr
  }
  
  let tokenResp
  let eumuser;


  // 1. Try to acquire token silently
  tokenResp = await this._msalClient.acquireTokenSilent(accessTokenRequest)
  console.log(`${Date.now()}-mytag--------------------- [auth.js] msalApp.acquireTokenSilent was successful`);
  console.log(tokenResp);
  this._eumstore.dispatch("authModule/SetTokens", tokenResp);

  return tokenResp;

};
function getAppUser() {
  if (!this._msalClient) {
    return null;
  }

  let _storedusr = this._eumstore.default.getters('authModule/storedAppUser');
  return _storedusr;
};

async function getMsalAccount() {

  if (!this._msalClient) {
    return null;
  }

  try {
    let str_usr = this._eumstore.getters['authModule/storedMsalUser'];

    if (str_usr) {
      return str_usr;
    } else if (this._msalClient.getAllAccounts() && this._msalClient.getAllAccounts().length > 0) {
      const currentAccount = this._msalClient.getAllAccounts()[0];

      currentAccount.idToken = {}
      currentAccount.accessToken = {}
      currentAccount.roles = []
      currentAccount.isLoggedIn = true;
      // this._eumstore.dispatch('authModule/SetMsalUser',currentAccount);
      this._msal_user = currentAccount;
      $setUser(currentAccount);
      this._msalClient.setActiveAccount(currentAccount);
      return currentAccount;

    }
  } catch (err) {
    console.log(`error in getMsalAccount(): ${err}`);
    return null;
  }
};




async function checkApiHealth() {
  let health = false;
  console.log(`[auth.js] Checking API health`);
  const config = {

  };
  const bodyParameters = {
    key: "value"
  };

  try {
    health = await axios.get(
      healthUrl, config
    );

    if (health.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }


};

async function authorizeAPI(tokenResp) {
  let eum_user = null;
  try {
    const config = {
      headers: { Authorization: `Bearer ${tokenResp.idToken}` }
    };

    eum_user = await axios.get(
      authUrl,
      config
    );

    if (eum_user == null) {
      return "";
    }
  } catch (err) {
    console.log(err);
  }
  try {
    if (eum_user != null && eum_user.data.Id &&
      (eum_user.data.UserRoles && eum_user.data.UserRoles.length > 0)) {
      eum_user.data.idToken = tokenResp.idToken;
      eum_user.data.apiIdToken = tokenResp.idToken;
      eum_user.data.idTokenExpiresOn = tokenResp.idTokenExpiresOn;
      this._eumstore.dispatch('authModule/SetAppUser', eum_user.data);
      this._eumstore.dispatch('authModule/SetTokens', tokenResp);
      this.app_user = eum_user.data;
      // check that initial load of data is complete or kick it off
      if (this._eumstore.getters['authModule/initialLoadDone']) {
        this._eumstore.dispatch('authModule/SetAuthStatus', 3);
      } else {
        await this.startInitialLoad();
      }

      return eum_user.data;

    } else {
      // console.log('[auth.js] acquireIdToken() eumuser is null or has no roles so return empty');
      localStorage.setItem("login_status", "fail");
      this._eumstore.dispatch('authModule/SetAuthStatus', 4);
      localStorage.removeItem(`${process.env.VUE_APP_EUM_ID_TOKEN}`);
      Object.keys(localStorage)
        .forEach(function (key) {
          if ((`/^${process.env.VUE_APP_EUM_LCL_KEY}/`.test(key))) {
            localStorage.removeItem(key);
          }
        });
      this._eumstore.dispatch('authModule/SetAuthStatus', 4);
      this._eumstore.dispatch('authModule/ClearTokens');
      return "";
    }
  } catch (err) {
    localStorage.setItem("login_status", "fail");
    this._eumstore.dispatch('authModule/SetAuthStatus', 4);
    this._eumstore.dispatch('authModule/ClearTokens');
    localStorage.removeItem(`${process.env.VUE_APP_EUM_ID_TOKEN}`);
    // console.log(`[auth.js] acquireIdToken() ERROR during authenticate API call -> `,err);
    return "";
  }

};
// async function authorize() {
//   let eum_user;

//   if (!this._msalClient) {
//     console.log('[auth.js] acquireIdToken() msalApp is null returning null')
//     return null
//   }
//   let appIdToken;
//   let apiIdToken;

//   let tokenresp = await this.getUIMsalToken();

//   let newapitoken = await this.authorizeAPI(tokenresp);


//   return newapitoken;
// };

async function startInitialLoad() {
  let self = this;
  // run these getItems in parallel but wait for them to finish
  await Promise.all(
    [ //this._eumstore.dispatch('getModelGetItems',UnitTypeConfig),
      apiUtil.methods._getItems(UnitClassConfig),
      apiUtil.methods._getItems(InvestmentConfig),
      apiUtil.methods._getItems(VestingScheduleConfig),
      this._eumstore.dispatch('getModule/GetItems', BaseModelInputControl),
      this._eumstore.dispatch('getModule/GetItems', BaseModelProgram)
     // apiUtil.methods._getItems(InputControlGridConfig),
     // apiUtil.methods._getItems(ProgramInfoGridConfig)
  ]);
      //apiUtil.methods._getItems(PartnerGridConfig)

      this._eumstore.dispatch('authModule/SetFirstLoginInProg', false);
      this._eumstore.dispatch('authModule/SetInitialLoadStatus', 2)
      this._eumstore.dispatch('getModule/GetAllItemsUnbundled');
};


// clear localstorage
function clearLocal() {
  if (this._msalClient) {
    for (let entry of Object.entries(localStorage)) {
      let key = entry[0]
      if (key.includes('login.windows')) {
        localStorage.removeItem(key)
      }
    }
    this._eumstore.dispatch('authModule/SetFirstAuthFlag', true);

    this._eumstore.dispatch('authModule/SetAuthStatus', 5);

  }
};

//
// Check if we have been setup & configured
//
function isConfigured() {
  return this._msalClient != null
};

export { AuthHelper, CreateAuthHelper }